import React from 'react';
import ConfettiExplosion from 'react-confetti-explosion';

function TargetNumber({ target, isExploding = false, onExplosionComplete = () => {} }) {
  const explosionParams = {
    force: 0.7,
    duration: 3000,
    particleCount: 225,
    width: 800,
  };

  return (
    <div>
      <h2>Target: {target}</h2>
      {isExploding && <ConfettiExplosion {...explosionParams} onComplete={onExplosionComplete} />}
    </div>
  );
}

export default TargetNumber;
